import { Droppable, DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';
import { darken } from 'polished';
import { DeepThoughtColor } from '@app/Areas/Optimus/Tokens/colors';
import styled from 'styled-components';

export interface MoveDropTileProps {
    droppableId: string;
    itemType: string;
    label: string;
}

export interface WrapperProps {
    isDraggingOver: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  max-height: 4em;
  width: 100%;
  border: 1px solid ${DeepThoughtColor};
  bord-radius: 2px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.isDraggingOver ? darken(0.3, DeepThoughtColor) : 'inherit'};
`;

function MoveDropTile({
    itemType,
    droppableId,
    label,
}: MoveDropTileProps) {
    return <Droppable droppableId={droppableId} type={itemType}>
    { (provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
        <Wrapper
            ref={provided.innerRef}
            { ...provided.droppableProps }
            isDraggingOver={snapshot.isDraggingOver}
        >
            { label }
        </Wrapper>
    )}
    </Droppable>
}

export default MoveDropTile;
